
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DiscardPackageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isBeforeThirtyDays: boolean;
}

const DiscardPackageDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isBeforeThirtyDays,
}: DiscardPackageDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isBeforeThirtyDays ? "Early Package Discard" : "Discard Package"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isBeforeThirtyDays
              ? "This package hasn't been in storage for 30 days yet. Are you sure you want to mark it as discarded?"
              : "Are you sure you want to mark this package as discarded?"}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Yes, discard it
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DiscardPackageDialog;
